<app-content>
  <app-breadcrumbs>
    <li>
      Jak korzystać?
    </li>
  </app-breadcrumbs>
  <section>
    <h2>
      Jak korzystać?
    </h2>
    <br>
    <div class="row">
      <h3>Poradnik dla mieszkańców</h3>
      <div class="col-md-12">
<iframe width="100%" height="600" src="https://www.youtube.com/embed/TbalzvDGsmc?si=ptUPNonPLy9zVOZp" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      </div>
    </div>
    <br /><br /><br />
    <div class="row">
      <h3>Poradnik dla przedsiębiorców</h3>
      <div class="col-md-12">
<iframe width="100%" height="600" src="https://www.youtube.com/embed/ECR4dRqGa-k?si=jZZa8AMYnChdufqV" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      </div>
    </div>
  </section>
  <br>
</app-content>
